type negativeCloseAccountFields = {
  screen: string
  screen_name: string
  object_name: string
  current_subscription: string
}

type pendingInvestmentsAccountFields = {
  screen: string
  screen_name: string
  object_name: string
  current_subscription: string
}

export const PlusUpgradeTapped = {
  object_name: 'myAccountsPlusUpgrade',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Upgrade to this plan',
}

export const PremiumUpgradeTapped = {
  object_name: 'myAccountsPremiumUpgrade',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Upgrade to this plan',
}

export const CloseLaterTapped = {
  object_name: 'myAccountsCloseLaterAccount',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Close Later Account',
}

export const CloseSpendTapped = {
  object_name: 'myAccountsCloseSpendAccount',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Close Checking Account',
}
export const CloseEarlyTapped = {
  object_name: 'myAccountsCloseEarlyAccount',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Close Early Account',
}

export const CancelSubscriptionTapped = {
  object_name: 'myAccountsCancelSubscription',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Cancel Subscription',
}

export const CloseAccountScreenViewed = {
  object_name: 'myAccounts',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Close account',
}

export const CloseAccountButtonTapped = {
  object_name: 'myAccountsClose',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const NegativeBalancePageViewedFields = (
  product: string,
): negativeCloseAccountFields => ({
  ...NegativeBalancePageViewedFields,
  object_name: 'myAccountsNegativeBalance',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  current_subscription: `${product}`,
})

export const NegativeBalanceContactSupport = {
  object_name: 'myAccountsNegativeBalanceContactSupportButton',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Contact support',
}

export const PendingInvestmentsPageViewedFields = (
  product: string,
): pendingInvestmentsAccountFields => ({
  ...NegativeBalancePageViewedFields,
  object_name: 'myAccountsPendingInvestments',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  current_subscription: `${product}`,
})

export const PendingInvestmentsTurnOffRecurring = {
  object_name: 'myAccountPendingInvestments',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Cancel recurring transfers ',
}

export const PendingInvestmentsViewHistory = {
  object_name: 'myAccountPendingInvestments',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'View history',
}

export const NoLinkedAccount = {
  object_name: 'myAccountLinkFundingSource',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const NoLinkedAccountButtonTapped = {
  object_name: 'myAccountLinkFundingSource',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const UpgradeSubscriptionCancelCTA = {
  object_name: 'upgradeSubscriptionConfirmationCancel',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Never mind',
}

export const UpgradeSubscriptionConfirmCTA = (
  previousTier: string,
  currentTier: string | undefined,
) => ({
  object_name: 'upgradeSubscriptionConfirmationConfirm',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Continue',
  previous_tier: previousTier,
  current_tier: currentTier,
})

export const UpgradeSubscriptionConfirmationModal = (tier: string) => ({
  object_name: 'UpgradeSubscriptionConfirmation',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  origin: tier,
})

export const GrandfatheredTierCard = {
  object_name: 'myAccountsGrandfatheredTierCard',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const UpgradeSubscriptionDone = {
  object_name: 'upgradeSubscriptionDone',
  screen: 'upgradeSubscriptionDone',
  screen_name: 'upgradeSubscriptionDone',
}

export const UpgradeSubscriptionDoneCTA = {
  object_name: 'upgradeSubscriptionDoneCTA',
  screen: 'upgradeSubscriptionDone',
  screen_name: 'upgradeSubscriptionDone',
  cta_title: "See what's new/'X'",
}

export const DowngradeModalViewed = {
  object_name: 'downgradeSubscriptionAlert',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const DowngradeModalCancelCTA = {
  object_name: 'downgradeSubscriptionAlertCancel',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Never mind',
}

export const DowngradeModalConfirmCTA = {
  object_name: 'downgradeSubscriptionAlertConfirm',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Change',
}

export const PassionsModalViewed = {
  object_name: 'passionsNotSupportedAlert',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const PassionsModalConfirmCTA = (cta: string) => ({
  object_name: 'passionsNotSupportedAlertConfirm',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: cta,
})
